<span fxFlex="100" fxLayoutAlign="start center" class="back-button">
    <mat-icon class="pl-0"><a> chevron_left </a></mat-icon>
    <span><a> Back </a></span>
</span>

